import { applySystemTheme } from './systemThemes';

const COLOR_MODE_KEY = 'aphenis_color_mode';

export type ColorMode = 'light' | 'dark';

export function getColorMode(): ColorMode {
  return (localStorage.getItem(COLOR_MODE_KEY) as ColorMode) || 'dark';
}

export function setColorMode(mode: ColorMode): void {
  try { localStorage.setItem(COLOR_MODE_KEY, mode); } catch {}
  applyColorMode(mode);
}

export function toggleColorMode(): ColorMode {
  const current = getColorMode();
  const next = current === 'dark' ? 'light' : 'dark';
  setColorMode(next);
  return next;
}

export function applyColorMode(mode?: ColorMode): void {
  const m = mode || getColorMode();
  const root = document.documentElement;
  if (m === 'dark') {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }
  // Re-apply or clear system theme overrides based on new mode
  applySystemTheme();
}

export function initColorMode(): void {
  applyColorMode();
}
